var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    [
      _c(
        "ContestEntryItem",
        {
          staticClass: "contest-entry-item",
          attrs: {
            name: _vm.$t("contestEntryUserForm.name.label"),
            required: _vm.isConfirm || _vm.isEdit ? undefined : true,
            error: _vm.errorMessage("name"),
          },
        },
        [
          _c("InputTextV2", {
            attrs: {
              type: "text",
              placeholder: _vm.$t("contestEntryUserForm.name.placeholder"),
              maxlength: 100,
              isDisplayCount: !_vm.isConfirm,
              readonly: _vm.isConfirm,
              error: !!_vm.errorMessage("name"),
            },
            model: {
              value: _vm.internalValue.name,
              callback: function ($$v) {
                _vm.$set(_vm.internalValue, "name", $$v)
              },
              expression: "internalValue.name",
            },
          }),
        ],
        1
      ),
      _c(
        "ContestEntryItem",
        {
          staticClass: "contest-entry-item",
          attrs: {
            name: _vm.$t("contestEntryUserForm.nameKana.label"),
            description: _vm.isConfirm
              ? undefined
              : _vm.$t("contestEntryUserForm.nameKana.description"),
            required: _vm.isConfirm || _vm.isEdit ? undefined : true,
            error: _vm.errorMessage("nameKana"),
          },
        },
        [
          _c("InputTextV2", {
            attrs: {
              type: "text",
              placeholder: _vm.$t("contestEntryUserForm.nameKana.placeholder"),
              maxlength: 100,
              isDisplayCount: !_vm.isConfirm,
              readonly: _vm.isConfirm,
              error: !!_vm.errorMessage("nameKana"),
            },
            model: {
              value: _vm.internalValue.nameKana,
              callback: function ($$v) {
                _vm.$set(_vm.internalValue, "nameKana", $$v)
              },
              expression: "internalValue.nameKana",
            },
          }),
        ],
        1
      ),
      _c(
        "ContestEntryItem",
        {
          staticClass: "contest-entry-item",
          attrs: {
            name: _vm.$t("contestEntryUserForm.penname.label"),
            required: _vm.isConfirm || _vm.isEdit ? undefined : true,
            description: _vm.isConfirm
              ? undefined
              : _vm.$t("contestEntryUserForm.penname.description"),
            error: _vm.errorMessage("penname"),
          },
        },
        [
          !_vm.isEdit
            ? [
                _c("SelectBoxV2", {
                  attrs: {
                    options: _vm.pennameOptions,
                    placeholder: _vm.$t(
                      "contestEntryUserForm.penname.placeholder"
                    ),
                    readonly: _vm.isConfirm,
                    error: !!_vm.errorMessage("penname"),
                  },
                  model: {
                    value: _vm.internalValue.penname,
                    callback: function ($$v) {
                      _vm.$set(_vm.internalValue, "penname", $$v)
                    },
                    expression: "internalValue.penname",
                  },
                }),
              ]
            : [
                _vm.contestUser
                  ? _c(
                      "div",
                      { staticClass: "tag-list" },
                      _vm._l(_vm.contestUser.penname, function (penname) {
                        return _c("TagItem", {
                          key: penname,
                          attrs: { text: penname, readonly: _vm.isConfirm },
                          on: {
                            delete: function ($event) {
                              return _vm.onClickDeletePenname(penname)
                            },
                          },
                        })
                      }),
                      1
                    )
                  : _c("div", { staticClass: "no-create" }, [
                      _vm._v(
                        _vm._s(
                          _vm.$t("contestEntryUserForm.penname.notCreated")
                        )
                      ),
                    ]),
              ],
          !_vm.isConfirm
            ? _c(
                "button",
                {
                  staticClass: "add-penname",
                  on: { click: _vm.onClickAddPenname },
                },
                [
                  _vm._v(
                    " " +
                      _vm._s(_vm.$t("contestEntryUserForm.penname.add")) +
                      " "
                  ),
                ]
              )
            : _vm._e(),
        ],
        2
      ),
      _c(
        "ContestEntryItem",
        {
          staticClass: "contest-entry-item",
          attrs: {
            name: _vm.$t("contestEntryUserForm.email.label"),
            description:
              _vm.isConfirm || _vm.isEdit
                ? undefined
                : _vm.$t("contestEntryUserForm.email.description"),
            required: _vm.isConfirm || _vm.isEdit ? undefined : true,
            error: _vm.errorMessage("email"),
          },
        },
        [
          _c("InputTextV2", {
            attrs: {
              type: "email",
              initialValue: _vm.cognitoUserEmail,
              placeholder: _vm.$t("contestEntryUserForm.email.placeholder"),
              maxlength: 100,
              isDisplayCount: !_vm.isConfirm,
              readonly: _vm.isConfirm,
              error: !!_vm.errorMessage("email"),
            },
            model: {
              value: _vm.internalValue.email,
              callback: function ($$v) {
                _vm.$set(_vm.internalValue, "email", $$v)
              },
              expression: "internalValue.email",
            },
          }),
        ],
        1
      ),
      _vm.internalValue.email !== _vm.cognitoUserEmail &&
      !_vm.isConfirm &&
      !_vm.isEdit
        ? _c(
            "ContestEntryItem",
            {
              staticClass: "contest-entry-item",
              attrs: {
                name: _vm.$t("contestEntryUserForm.emailConfirm.label"),
                required: _vm.isConfirm || _vm.isEdit ? undefined : true,
                error: _vm.errorMessage("emailConfirm"),
              },
            },
            [
              _c("InputTextV2", {
                attrs: {
                  type: "email",
                  placeholder: _vm.$t(
                    "contestEntryUserForm.emailConfirm.placeholder"
                  ),
                  maxlength: 100,
                  isDisplayCount: !_vm.isConfirm,
                  readonly: _vm.isConfirm,
                  error: !!_vm.errorMessage("emailConfirm"),
                },
                model: {
                  value: _vm.internalValue.emailConfirm,
                  callback: function ($$v) {
                    _vm.$set(_vm.internalValue, "emailConfirm", $$v)
                  },
                  expression: "internalValue.emailConfirm",
                },
              }),
            ],
            1
          )
        : _vm._e(),
      _c(
        "ContestEntryItem",
        {
          staticClass: "contest-entry-item",
          attrs: {
            name: _vm.$t("contestEntryUserForm.phone.label"),
            description: _vm.isConfirm
              ? undefined
              : _vm.$t("contestEntryUserForm.phone.description"),
            required: _vm.isConfirm || _vm.isEdit ? undefined : true,
            error: _vm.errorMessage("phone"),
          },
        },
        [
          _c("InputTextV2", {
            attrs: {
              type: "tel",
              placeholder: _vm.$t("contestEntryUserForm.phone.placeholder"),
              maxlength: 11,
              isDisplayCount: !_vm.isConfirm,
              readonly: _vm.isConfirm,
              error: !!_vm.errorMessage("phone"),
            },
            model: {
              value: _vm.internalValue.phone,
              callback: function ($$v) {
                _vm.$set(_vm.internalValue, "phone", $$v)
              },
              expression: "internalValue.phone",
            },
          }),
        ],
        1
      ),
      _c(
        "ContestEntryItem",
        {
          staticClass: "contest-entry-item",
          attrs: {
            name: _vm.$t("contestEntryUserForm.gender.label"),
            required: _vm.isConfirm || _vm.isEdit ? undefined : true,
            error: _vm.errorMessage("gender"),
          },
        },
        [
          _c("SelectBoxV2", {
            attrs: {
              options: _vm.genderOptions,
              placeholder: _vm.$t("contestEntryUserForm.gender.placeholder"),
              allowUnselected: _vm.isEdit,
              readonly: _vm.isConfirm,
              error: !!_vm.errorMessage("gender"),
            },
            model: {
              value: _vm.internalValue.gender,
              callback: function ($$v) {
                _vm.$set(_vm.internalValue, "gender", $$v)
              },
              expression: "internalValue.gender",
            },
          }),
        ],
        1
      ),
      _c(
        "ContestEntryItem",
        {
          staticClass: "contest-entry-item",
          attrs: {
            name: _vm.$t("contestEntryUserForm.birthdate.label"),
            required: _vm.isConfirm || _vm.isEdit ? undefined : true,
            error: _vm.errorMessage("birthdate"),
          },
        },
        [
          _c("DatePicker", {
            attrs: {
              format: "yyyy/MM/dd",
              language: _vm.datePickerLanguage,
              placeholder: _vm.$t("contestEntryUserForm.birthdate.placeholder"),
              typeable: "",
              disabled: _vm.isConfirm,
              inputClass: {
                "input-wrapper": true,
                "date-picker": true,
                error: !!_vm.errorMessage("birthdate"),
              },
            },
            model: {
              value: _vm.internalValue.birthdate,
              callback: function ($$v) {
                _vm.$set(_vm.internalValue, "birthdate", $$v)
              },
              expression: "internalValue.birthdate",
            },
          }),
        ],
        1
      ),
      _c(
        "ContestEntryItem",
        {
          staticClass: "contest-entry-item",
          attrs: {
            name: _vm.$t("contestEntryUserForm.historyOfAwards.label"),
            description: _vm.isConfirm
              ? undefined
              : _vm.$t("contestEntryUserForm.historyOfAwards.description"),
            required: _vm.isConfirm || _vm.isEdit ? undefined : false,
            error: _vm.errorMessage("historyOfAwards"),
          },
        },
        [
          _c("InputTextV2", {
            attrs: {
              rows: 5,
              placeholder: _vm.$t(
                "contestEntryUserForm.historyOfAwards.placeholder"
              ),
              maxlength: 500,
              isDisplayCount: !_vm.isConfirm,
              readonly: _vm.isConfirm,
              error: !!_vm.errorMessage("historyOfAwards"),
            },
            model: {
              value: _vm.internalValue.historyOfAwards,
              callback: function ($$v) {
                _vm.$set(_vm.internalValue, "historyOfAwards", $$v)
              },
              expression: "internalValue.historyOfAwards",
            },
          }),
        ],
        1
      ),
      !_vm.isEdit
        ? [
            !_vm.isConfirm && _vm.contest
              ? _c(
                  "ContestEntryItem",
                  {
                    staticClass: "contest-entry-item",
                    attrs: {
                      name: _vm.$t("contestEntryUserForm.terms.label"),
                      description: _vm.isConfirm
                        ? undefined
                        : _vm.$t("contestEntryUserForm.terms.description"),
                      required: _vm.isConfirm ? undefined : true,
                    },
                  },
                  [
                    _c("InputTextV2", {
                      attrs: {
                        rows: 20,
                        value: _vm.contest.terms,
                        readonly: "",
                      },
                    }),
                    _c(
                      "div",
                      { staticClass: "input-wrapper terms" },
                      [
                        _c("CheckboxItem", {
                          attrs: {
                            text: _vm.$t("contestEntryUserForm.terms.agree"),
                          },
                          model: {
                            value: _vm.internalValue.isAgreedTerms,
                            callback: function ($$v) {
                              _vm.$set(_vm.internalValue, "isAgreedTerms", $$v)
                            },
                            expression: "internalValue.isAgreedTerms",
                          },
                        }),
                      ],
                      1
                    ),
                  ],
                  1
                )
              : _vm._e(),
            _c(
              "ContestEntryItem",
              {
                staticClass: "contest-entry-item",
                attrs: {
                  name: _vm.$t("contestEntryUserForm.saveInfo.label"),
                  description: _vm.isConfirm
                    ? undefined
                    : _vm.$t("contestEntryUserForm.saveInfo.description"),
                  required: _vm.isConfirm ? undefined : false,
                },
              },
              [
                _c(
                  "div",
                  {
                    staticClass: "input-wrapper",
                    class: { readonly: _vm.isConfirm },
                  },
                  [
                    !_vm.isConfirm
                      ? _c("CheckboxItem", {
                          attrs: {
                            text: _vm.$t(
                              "contestEntryUserForm.saveInfo.checkbox"
                            ),
                          },
                          model: {
                            value: _vm.internalValue.isSaveEntryUser,
                            callback: function ($$v) {
                              _vm.$set(
                                _vm.internalValue,
                                "isSaveEntryUser",
                                $$v
                              )
                            },
                            expression: "internalValue.isSaveEntryUser",
                          },
                        })
                      : _c("div", [
                          _vm._v(
                            " " +
                              _vm._s(
                                _vm.internalValue.isSaveEntryUser
                                  ? _vm.$t(
                                      "contestEntryUserForm.saveInfo.willSave"
                                    )
                                  : _vm.$t(
                                      "contestEntryUserForm.saveInfo.willNotSave"
                                    )
                              ) +
                              " "
                          ),
                        ]),
                  ],
                  1
                ),
              ]
            ),
          ]
        : _vm._e(),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }